import React, { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/HeroNew';
import About from './components/About/About';
import Services from './components/Services/Services';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import Team from './components/Team/Team';
import Footer from './components/Footer/Footer';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const navigateTo = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'services':
        return <Services navigateTo={navigateTo} />;
      case 'team':
        return <Team navigateTo={navigateTo} />;
      case 'projects':
        return <Projects navigateTo={navigateTo} />;
      case 'contact':
        return <Contact navigateTo={navigateTo} />;
      case 'home':
      default:
        return (
          <>
            <Hero navigateTo={navigateTo} />
            <About navigateTo={navigateTo} />
          </>
        );
    }
  };

  return (
    <div className="App">
      <Navbar navigateTo={navigateTo} currentPage={currentPage} />
      <main>
        {renderPage()}
      </main>
      <Footer navigateTo={navigateTo} currentPage={currentPage} />
    </div>
  );
}

export default App;
